import axios from 'axios';

export const BASE_URL = process.env.NEXT_PUBLIC_BASE_URL;
export const BASE_GQL_URL = process.env.NEXT_PUBLIC_BASE_GQL_URL;
export const BASE_REST_URL = process.env.NEXT_PUBLIC_BASE_URL_V2;

const axiosClient = axios.create({
  baseURL: BASE_REST_URL,
  headers: {
    'Content-Type': 'application/json',
    'Cache-Control': process.env.NEXT_PUBLIC_CACHE_CONTROL ?? '',
    'App-Id': process.env.NEXT_PUBLIC_APP_ID ?? '',
  },
});

axiosClient.interceptors.request.use(
  (config) => {
    const token = process.env.NEXT_PUBLIC_STUDENT_API_TOKEN;
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    // const appId: number = 1;
    // if (Number.isInteger(appId)) {
    //   config.headers["app-id"] = appId;
    // } else {
    //   console.error("Invalid app-id. It must be an integer.");
    //   throw new Error("Invalid app-id. Must be an integer.");
    // }
    return config;
  },
  (error) => {
    return Promise.reject(error instanceof Error ? error : new Error(String(error)));
  },
);

axiosClient.interceptors.response.use(
  (response) => response,
  (error) => {
    return Promise.reject(error instanceof Error ? error : new Error(String(error)));
  },
);

export default axiosClient;
